import { Instance, flow, types } from 'mobx-state-tree';

import { getMeetLessons } from '@common/api/meets';
import { LessonData } from '@common/types/academyReworkings';

const StudentLessons = types
	.model('AcademyStudentLessons', {
		studentId: types.number,
		groupId: types.number,
		data: types.optional(types.frozen<LessonData>(), { programs: [], lessons: [] }),
	})
	.volatile(() => ({ loading: false }))
	.actions((self) => ({
		fetch: flow(function* (programId?: number) {
			self.loading = true;
			try {
				const result: LessonData = yield getMeetLessons(self.studentId, self.groupId, programId);
				self.data = result;
				return result;
			} finally {
				self.loading = false;
			}
		}),
	}));

export default StudentLessons;
export interface IStudentLessonsModel extends Instance<typeof StudentLessons> {}
